export default "__VITE_ASSET__CZ7K5E_M__"